import React, { createContext, useContext, useState } from 'react';
import { DateFromTo } from '../../../server-types';

interface ContextProps {
    dateFromTo?: DateFromTo;
    setDateFromTo: (arg?: DateFromTo) => void;
    resetDateFromTo: () => void;
}

const defaultState = {
    dateFromTo: undefined,
    setDateFromTo: () => {},
    resetDateFromTo: () => {}
};

const FromToContext = createContext<ContextProps>(defaultState);

export const FromToContextProvider: React.FC<{ dateFromTo?: DateFromTo }> = ({ children, dateFromTo }) => {
    const context = useProvideFromToContext(dateFromTo);

    return <FromToContext.Provider value={context}>{children}</FromToContext.Provider>;
};

export const useFromToContext = () => {
    return useContext(FromToContext);
};

function useProvideFromToContext(initialState?: DateFromTo ) {
    const [dateFromTo, setDateFromTo] = useState<ContextProps['dateFromTo']>(initialState || defaultState.dateFromTo);
    const resetDateFromTo = () => setDateFromTo(initialState || defaultState.dateFromTo);
    return {
        dateFromTo,
        setDateFromTo,
        resetDateFromTo,
    };
}
